import { Directive } from "@angular/core";

@Directive({
	selector: "[timeCardContent]",
})
export class TimeTrackerTableCardContentDirective {
	constructor() {}
}
